import { computed, observable } from "mobx";
import { Type } from "class-transformer";
import LanguageCode from "./languageCode";
import SentEmailMessageChargeResponse from "./sentEmailMessageChargeResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
class SentEmailMessageResponse {
  /**
   * Date and time email was sent.
   */
  @observable
  @Type(() => Date)
  sentAt!: Date;

  /**
   * Count of charges related to email message.
   */
  @observable
  chargesCount!: number;

  @observable
  @Type(() => SentEmailMessageChargeResponse)
  charge?: SentEmailMessageChargeResponse;

  /**
   * Charge order ID or null in case email message is related to more charge orders.
   */
  @observable
  chargeOrderId?: string;

  /**
   * Order ident or null in case email message is related to more charge orders.
   */
  @observable
  orderIdent?: number;

  /**
   * Email subject.
   */
  @observable
  subject!: string;

  /**
   * Recipient email address.
   */
  @observable
  recipient!: string;

  @observable
  languageCode?: LanguageCode;

  @observable
  _vehicle?: string;

  @observable
  _validSince?: string;

  @observable
  _validUntil?: string;

  @observable
  _fuelType?: string;

  @observable
  _chargeType?: string;
}

export default class SentEmailMessage extends SentEmailMessageResponse {
  @computed
  get searchId() {
    if (this.charge) {
      return `${new Date(this.sentAt).getTime().toString()}-${this.charge.id}`;
    } else {
      return new Date(this.sentAt).getTime().toString();
    }
  }
}
